/**
 * Contact for Pricing — Modal JS
 * File: assets/contact-pricing.js
 */

(function () {
  'use strict';

  function initCFP() {
    const trigger   = document.getElementById('cfp-trigger');
    const modal     = document.getElementById('cfp-modal');
    const closeBtn  = document.getElementById('cfp-close');
    const form      = document.getElementById('cfp-contact-form');
    const submitBtn = document.getElementById('cfp-submit');
    const resetBtn  = document.getElementById('cfp-reset');

    if (!trigger || !modal) return;

    /* ── TELEPORT modal to <body> so fixed positioning works correctly ──
       Some themes use transform/will-change on product containers which
       breaks position:fixed. Moving to body fixes this.                  */
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    /* ── Find site header ── */
    const siteHeader = document.querySelector(
      'sticky-header, header-drawer, header, .header, #shopify-section-header, [class*="site-header"], [class*="header-wrapper"]'
    );
    var originalHeaderZIndex = '';

    /* ── Clean URL if Shopify added contact params after form submit ── */
    if (window.location.search.indexOf('contact_posted=true') !== -1) {
      window.history.replaceState(null, '', window.location.pathname);
      openModal();
      showSuccess();
    }

    /* ── Open ── */
    function openModal() {
      modal.removeAttribute('hidden');
      requestAnimationFrame(function () {
        modal.classList.add('cfp-visible');
      });
      document.body.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');

      if (siteHeader) {
        originalHeaderZIndex = siteHeader.style.zIndex;
        siteHeader.style.zIndex = '0';
      }

      setTimeout(function () {
        var first = modal.querySelector('input:not([type="hidden"])');
        if (first) first.focus();
      }, 300);
    }

    /* ── Close ── */
    function closeModal() {
      modal.classList.remove('cfp-visible');
      document.body.style.overflow = '';
      trigger.setAttribute('aria-expanded', 'false');

      if (siteHeader) {
        siteHeader.style.zIndex = originalHeaderZIndex;
      }

      setTimeout(function () {
        modal.setAttribute('hidden', '');
      }, 300);
    }

    /* ── Show Success inside modal ── */
    function showSuccess() {
      var formBody    = modal.querySelector('.cfp-form-body');
      var formFooter  = modal.querySelector('.cfp-form-footer');
      var modalHeader = modal.querySelector('.cfp-modal-header');

      if (formBody)    formBody.style.display = 'none';
      if (formFooter)  formFooter.style.display = 'none';
      if (modalHeader) modalHeader.style.display = 'none';

      var existing = modal.querySelector('.cfp-success-state');
      if (existing) existing.remove();

      var success = document.createElement('div');
      success.className = 'cfp-success-state';
      success.innerHTML = [
        '<div class="cfp-success-icon">',
          '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">',
            '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>',
            '<polyline points="22 4 12 14.01 9 11.01"/>',
          '</svg>',
        '</div>',
        '<h3>Quote Request Sent!</h3>',
        '<p>Thank you! We\u2019ll get back to you with pricing shortly.</p>',
        '<button type="button" class="cfp-reset-btn" id="cfp-reset-btn">Submit Another Request</button>'
      ].join('');

      var panel = modal.querySelector('.cfp-modal-panel');
      panel.appendChild(success);

      document.getElementById('cfp-reset-btn').addEventListener('click', function () {
        window.location.href = window.location.pathname;
      });
    }

    trigger.addEventListener('click', openModal);
    closeBtn && closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('cfp-visible')) {
        closeModal();
      }
    });

    /* ── Native form submit loading state ── */
    if (form && submitBtn) {
      form.addEventListener('submit', function () {
        var textEl   = submitBtn.querySelector('.cfp-submit-text');
        var loaderEl = submitBtn.querySelector('.cfp-submit-loader');
        submitBtn.disabled = true;
        if (textEl)   textEl.textContent = 'Sending\u2026';
        if (loaderEl) loaderEl.removeAttribute('hidden');
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        window.location.href = window.location.pathname;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCFP);
  } else {
    initCFP();
  }

})();
